import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollTopButton from '@/components/feature/ScrollTopButton';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="pt-20 min-h-[70vh] flex items-center justify-center px-4 bg-background-50">
        <div className="text-center max-w-lg">
          <div className="relative mb-8">
            <span className="text-[8rem] md:text-[10rem] font-heading font-bold text-background-200 select-none leading-none">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-question-mark text-3xl"></i>
              </div>
            </div>
          </div>
          <h1 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-500 mb-2">
            抱歉，你访问的页面不存在或已被移除
          </p>
          <p className="text-xs text-foreground-400 font-mono mb-8">{location.pathname}</p>
          <Link
            to="/"
            className="inline-flex px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-xs"></i>
            </span>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
      <ScrollTopButton />
    </>
  );
}